import MainLayout from "@/components/layout/MainLayout";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CalendarDays, Loader2 } from "lucide-react";
import CurrentEditionKnowCard from "@/components/currentEdition/CurrentEditionKnowCard";
import AdoptionFlowPanel from "@/components/currentEdition/AdoptionFlowPanel";
import { useCurrentEditionAdoption } from "@/hooks/useCurrentEditionAdoption";

/**
 * The Current Edition of Your Constitution.
 * Know, do, schedule. Plain words only.
 */
export default function CurrentEditionAdoption() {
  const { eligible, adoption, signers, signedCount, loading, reload, unaName } =
    useCurrentEditionAdoption();

  return (
    <MainLayout>
      <div className="mx-auto w-full max-w-3xl space-y-6 px-4 py-6 sm:py-8">
        <header className="space-y-1">
          <h1 className="text-2xl font-semibold tracking-tight sm:text-3xl">
            The Current Edition of Your Constitution
          </h1>
          <p className="text-sm text-muted-foreground">
            {unaName ? `For ${unaName}.` : "For your Association."} One clear set of governing
            papers, adopted by every member.
          </p>
        </header>

        {loading ? (
          <div className="flex items-center gap-2 py-12 text-sm text-muted-foreground">
            <Loader2 className="h-4 w-4 animate-spin" />
            Loading your Association
          </div>
        ) : (
          <>
            <CurrentEditionKnowCard />

            <AdoptionFlowPanel
              eligible={eligible}
              adoption={adoption}
              signers={signers}
              signedCount={signedCount}
              onChanged={reload}
            />

            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2 text-lg">
                  <CalendarDays className="h-5 w-5 text-primary" />
                  What to schedule
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-2 text-sm leading-relaxed">
                <p>Nothing repeats. This is a one time step.</p>
                <p>
                  Note the date you adopt the current edition. That date belongs in your governance
                  record, and we file it there for you when every member has signed.
                </p>
              </CardContent>
            </Card>
          </>
        )}
      </div>
    </MainLayout>
  );
}
